<template>
  <v-card tag="label" class="drag pa-5 ma-5" :color="drag ? 'primary' : null" :elevation="drag ? 5 : 1">
    <!--  TODO: fix accept on non-image file upload implementation  -->
    <input
      class="input"
      type="file"
      accept="image/*"
      multiple
      @dragenter="drag = true"
      @dragleave="drag = false"
      @dragend="drag = false"
      @drop="drag = false"
      @change="handleFilesDrop"
    >
    <v-icon class="mdi mdi-cloud-upload-outline text-center ma-auto d-block mdi-48px icon" />
    <p class="mt-2 text-center">
      Drop Your Images Here!
    </p>
  </v-card>
</template>

<script>
  export default {
    name: 'DragFileInput',
    data () {
      return {
        drag: false
      }
    },
    methods: {
      handleFilesDrop (event) {
        this.$emit('upload', Array.from(event.target.files))
      }
    }
  }
</script>

<style lang="sass" scoped>
  @use "../../../../assets/sass/core/mixins"

  .drag
    cursor: pointer
    position: relative
    transition: .4s ease-out
    transition-property: box-shadow, background-color

  .input
    @include mixins.fill-parent
    @include mixins.square(100%)
    opacity: 0
    z-index: 10
  // HACK: icon pseudos size breaks horizontal overflow
  .icon::after
    width: auto
</style>
